<template>
  <div class="main-cj-box">

    <div class="cj-name-box flex ac jb">
      <div class="flex ac">
        <div style="width: 240px" v-if="inputState">
          <el-input
            ref="inputRef"
            @blur="handleBlur"
            placeholder="请输入作品名称"
            v-model="name"
            clearable>
          </el-input>
        </div>
        <p class="pp2 cr" @click="showInput" v-if="!inputState">{{textName}}</p>
        <i class="el-icon-edit-outline cr ml05" @click="showInput"></i>
      </div>
      <div class="flex ac">
        <el-popover
          placement="left-start"
          trigger="hover"
        >
          <template>
            <div class="hover-pop-box cr">
              <p> • 预估时长是我们根据系统声音合成速率估算得出，</p>
              <p> • 与实际作品时长存在误差，积分扣除以最终实际合成时长为准；</p>
            </div>
          </template>
          <template slot="reference">
            <img class="tishi-img" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_7.png"
                 alt="">
          </template>
        </el-popover>
        <p :style="{ color: theme.worksColor2 }">预估总时长：<span style="color: #01FBF5 ">{{formatTime(allYgTimes)}}</span>
        </p>
      </div>
    </div>
    <div class="dcj-info-box flex">
      <div class="left-info-box" ref="scrollContainer">
        <div class="" v-for="(item,index) in multiplesArray" :key="item.id || index">
          <div class="every-chang-jing">
            <div class="cj-title-box flex ac jb cr">
              <p>场景{{index+1}}</p>

              <div class="flex ac">
                <p :class="item.type=='text'?'choosed-info':'moren-info-box'" @click="chooseInfo(index ,'text')">
                  文本内容</p>
                <p :class="item.type=='audio'?'choosed-info':'moren-info-box'" @click="chooseInfo(index,'audio')">
                  音频内容</p>
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_Del.png"
                     @click="handleDelCj(index)" alt="">
              </div>

            </div>
            <div class='flex ac'>
              <div class="left1-box">
                <img :src="item.cover" alt="">
                <div class="qie-huan-btn cr" @click="handleGhVideo(index)">
                  <div class="flex ac jc">
                    <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_3.png" alt="">
                    <p>更换</p>
                  </div>
                </div>
              </div>
              <div class="voice-up-box flex ac jc" v-if="item.type == 'audio'">
                <div class="up-voice-info flex ac jb" v-if="item.voiceUpName&&item.upVoiceUrl">
                  <img class="voiceUp1" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/3.2_Icon1.png"
                       alt="">
                  <div class="voiceUp2">
                    <p class="voice-text1 te">{{item.voiceUpName}}</p>
                    <p class="voice-text2 te">{{formatTime(item.voiceUpDuration)}}</p>
                  </div>

                  <div>
                    <div class="voiceUp3 flex ac jc cr">
                      <div class="flex ac jc" v-if="item.shitingplayState==1" @click="handlePlayUpVoice(index,1)">
                        <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_4.png" alt="">
                        <p>播放</p>
                      </div>
                      <div class="flex ac jc" v-if="item.shitingplayState==2" @click="handlePlayUpVoice(index,2)">
                        <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_pause.png"
                             alt="">
                        <p>播放中</p>
                      </div>
                    </div>
                    <div class="voiceUp3 flex ac jc cr mt05">
                      <div class="flex ac jc" @click="handleDelUpVoice(index)">
                        <i class="el-icon-delete mr05"></i>
                        <p>删除</p>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-else>
                  <el-upload
                    :ref="`upload${index}`"
                    :action="uploadUrl"
                    :show-file-list="false"
                    accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
                    :on-success="(file)=> handleFileUpSuccess2(file,index)"
                    :on-error="handleFileUpError"
                    :on-remove="handleRemove"
                    :before-upload="(file)=> beforeAvatarUpload2(file,index)"
                    multiple
                    :limit="1"
                    :headers="myHeaders"
                    :data="needParam"
                  >
                    <el-button type="primary" icon="el-icon-plus" style="background: #6C14FF;border: none">上传音频
                    </el-button>
                  </el-upload>
                </div>
              </div>
              <div v-if="item.type == 'text'" class="flex ac">
                <div class="rich-text-box">
                  <div class='all-editBox'>
                    <editable-div class='editBox' v-model="item.content"
                                  @changeText="(value)=>bindDateChange(value,index)"
                    ></editable-div>

                    <div class="handle-rich-box flex ac cr">
                      <div class="st-part flex ac jc mr10" v-if="item.shitingplayState==1"
                           @click="handleShiTing(1,index)">
                        <img :src="theme.createIcon7" alt="">
                        <p>试听</p>
                      </div>
                      <div class="st-part flex ac jc mr10" v-if="item.shitingplayState==2"
                           @click="handleShiTing(2,index)">
                        <img :src="theme.createIcon10" alt="" style="width: 12px;height: 12px;margin-right: 5px">
                        <p>试听中</p>
                      </div>
                      <el-popover
                        ref="myPopover"
                        aria-hidden="true"
                        placement="top"
                        v-model="item.visible"
                        append-to-body
                        :popper-options="{ boundariesElement: 'scrollContainer' }"
                        trigger="manual">
                        <div>
                          <el-button size="mini" @click.stop="insertImg({name:'停顿0.2s',code:0.2})">停顿0.2s</el-button>
                          <el-button size="mini" @click.stop="insertImg({name:'停顿0.3s',code:0.3})">停顿0.3s</el-button>
                          <el-button size="mini" @click.stop="insertImg({name:'停顿0.5s',code:0.5})">停顿0.5s</el-button>
                          <el-button size="mini" @click.stop="insertImg({name:'停顿1s',code:1})">停顿1s</el-button>
                          <el-button size="mini" @click.stop="insertImg({name:'停顿2s',code:2})">停顿2s</el-button>
                        </div>
                        <el-button v-if="theme.id==1&&item.placeholderApi!='fish'&&item.placeholderApi!='nw'" size="mini"
                                   style="background: rgba(255, 255, 255, 0.1);border: none;color: #ffffff"
                                   slot="reference"
                                   icon="el-icon-s-fold" @click="handleInsert(item,index)">插入停顿
                        </el-button>
                        <el-button v-if="theme.id==2&&item.placeholderApi!='fish'&&item.placeholderApi!='nw'" size="mini"
                                   style="background: rgba(255, 255, 255, 0.1);color: #333333"
                                   slot="reference"
                                   icon="el-icon-s-fold" @click="handleInsert(item,index)">插入停顿
                        </el-button>
                      </el-popover>
                    </div>
                  </div>
                </div>
                <div class="cj-right-box">
                  <div class="yp-title-box flex ac jb">
                    <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_1.png" alt="">
                    <div class="yp-title-middle ">
                      <p class="te yp-text1">{{item.voice_name}}</p>
                      <p class="te yp-text2">{{site_title}}{{item.version_name}}</p>
                    </div>
                    <div class="yp-title-btn cr" @click="handleGhVoice(index)">更换</div>
                  </div>

                  <!--    音频参数调节    -->
                  <div class="voice-tj-box cr">
                    <div class="flex ac jb">
                      <p class="text1">音频参数调节</p>
                      <!-- <div class="flex ac ">-->
                      <!--   <div class="flex ac jc btn11 mr05" @click="handleQrxg">-->
                      <!--     <p>确认修改</p>-->
                      <!--    </div>-->
                      <!--  <div class="flex ac jc btn22" @click="handleHhmr">-->
                      <!--   <p>恢复默认</p>-->
                      <!--    </div>-->
                      <!--    </div>-->
                    </div>
                    <div class="shezhi-box">
                      <div class="flex ac part-slider">
                        <span class="mr20">语速</span>
                        <el-slider style="width: 80%" v-model="item.rate" :step="0.1" :min="0.5" :max="2"></el-slider>
                      </div>
                      <div class="flex ac part-slider">
                        <span class="mr20">音量</span>
                        <el-slider style="width: 80%" v-model="item.volume" :step="0.1" :min="0.1" :max="3"></el-slider>
                      </div>
                      <div class="flex ac part-slider">
                        <span class="mr20">语调</span>
                        <el-slider style="width: 80%" v-model="item.pitch" :step="0.1" :min="0.1" :max="2"></el-slider>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="add-info-box flex jfe cr">
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :show-file-list="false"
            accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
            :on-success="handleFileUpSuccess"
            :on-error="handleFileUpError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :headers="myHeaders"
            :data="needParam"
          >
            <el-button type="primary" icon="el-icon-plus" style="background: #6C14FF;border: none">添加音频场景</el-button>
          </el-upload>
          <div class="ml15">
            <el-button type="primary" icon="el-icon-plus" style="background: #6C14FF;border: none" @click="addWenText">
              添加文本场景
            </el-button>
          </div>
        </div>
      </div>
      <div class="right-info-box">
        <div class="gj-title flex ac">
          <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_6.png" alt="">
          <p>高级选项</p>
        </div>
        <div class="">
          <el-popover
            placement="left-start"
            trigger="hover"
          >
            <template>
              <div class="hover-pop-box cr">
                <p class="bold">选择数字人视频在驱动时的模式：</p>
                <p> • 顺序驱动：使用数字人生成作品时会从你上传的原始视频第一帧开始顺序驱动</p>
                <p> • 随机模式：随机挑选片段来进行驱动（生成的音频时长超过原视频长度时，按照顺序驱动，不会走随机模式）</p>
              </div>
            </template>
            <template slot="reference">
              <div class="small-title flex ac">
                <p>驱动模式</p>
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_7.png" alt="">
              </div>

            </template>
          </el-popover>
          <div class="choose-ms-box flex ac jb cr">
            <div class="" :class="drive_mode=='serial'?'xz-ys-box': 'moren-ys-box'" @click="chooseMode('serial')">顺序模式
            </div>
            <div class="" :class="drive_mode=='random'?'xz-ys-box': 'moren-ys-box'" @click="chooseMode('random')">随机模式
            </div>
          </div>
        </div>
        <div class="">
          <el-popover
            placement="left-start"
            trigger="hover"
          >
            <template>
              <div class="hover-pop-box cr">
                <p class="bold">选择数字人视频在驱动时的模式：</p>
                <p> • 驱动视频：正常驱动数字人的视频作品</p>
                <p> • 仅音频：仅输出驱动后的音频文件</p>
              </div>
            </template>
            <template slot="reference">
              <div class="small-title flex ac">
                <p>输出设置</p>
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_7.png" alt="">
              </div>

            </template>
          </el-popover>
          <div class="choose-ms-box flex ac jb cr">
            <div class="" :class="output_mode=='video'?'xz-ys-box': 'moren-ys-box'" @click="chooseMode2('video')">驱动视频
            </div>
            <div class="" :class="output_mode=='audio'?'xz-ys-box': 'moren-ys-box'" @click="chooseMode2('audio')">仅音频
            </div>
          </div>
        </div>

        <div class="">
          <el-popover
            placement="left-start"
            trigger="hover"
          >
            <template>
              <div class="hover-pop-box cr">
                <p>• 积分模式：创作消耗积分<br>• 批量生成每个场景的视频作品和一条合成作品
                  <br>• 每个场景的视频作品15积分/每秒</p>
              </div>
            </template>
            <template slot="reference">
              <div class="small-title flex ac">
                <p>生成模式</p>
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_7.png" alt="">
              </div>

            </template>
          </el-popover>
          <div class="choose-ms-box flex ac jb cr">
            <div class="dan-xz-ys-box">积分模式</div>
          </div>
        </div>
        <div class="">
          <el-popover
            placement="left-start"
            trigger="hover"
          >
            <template>
              <div class="hover-pop-box cr">
                <p> • 仅支持3.0模型生成</p>
              </div>
            </template>
            <template slot="reference">
              <div class="small-title flex ac">
                <p>选择模型</p>
                <img src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/13.1_Icon_7.png" alt="">
              </div>

            </template>
          </el-popover>
          <div class="choose-ms-box flex ac jb cr">
            <div class="dan-xz-ys-box">V3.0</div>
          </div>
        </div>

      </div>
    </div>
    <div class="bottom-hc-box flex ac jfe cr" @click="preview()">
      <p>提交合成</p>
    </div>


    <div class="video-dailog-box">
      <el-dialog
        :visible.sync="dialogVisible"
        width="75%"
      >
        <div class="dialog-video">
          <img class="close-img cr" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.2_IconClose.png"
               alt="1" @click="dialogVisible = false">

          <div class="part1-box">
            <div class="select-box">
              <div class="flex ac jb cr">
                <div class="flex ac">
                  <div class="pp1" :style="{ color: titleState==1 ? '#222222' : ''}"
                       @click="handleChoose1(1)">公共形象
                  </div>
                  <div class="pp1" :style="{ color: titleState==2 ? '#222222' : ''}"
                       @click="handleChoose1(2)">我的形象
                  </div>
                </div>
                <div class="hs-box flex ac" v-if="titleState==1">
                  <div class="normal"
                       :style="{ color: hsState==1? '#ffffff' : '', backgroundColor: hsState==1 ? '#6C14FF' : ''}"
                       @click="handleHs(1)">横版
                  </div>
                  <div class="normal"
                       :style="{ color: hsState==2? '#ffffff' : '', backgroundColor: hsState==2 ? '#6C14FF' : ''}"
                       @click="handleHs(2)">竖版
                  </div>
                </div>
              </div>
            </div>
            <div v-if="titleState==1" class="flex ac cr fw all-video-y">
              <div v-for="(item,index) in videoArray" :key="index" class="all-every-me-fs" v-if="hsState==2">
                <div class="every-me-fs" :class="chooseVideoId==item.id?'actived':''"
                     :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                     @click="handleChooseVideo(item)" @dblclick="handleDblclickVideo(item)">
                </div>
                <p class="tc te every-me-text">{{item.name}}</p>
              </div>

              <div v-for="(item,index) in videoArray" :key="index" class="all-every-me-fs-h" v-if="hsState==1">
                <div class="every-me-fs-h" :class="chooseVideoId==item.id?'actived-h':''"
                     :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                     @click="handleChooseVideo(item)" @dblclick="handleDblclickVideo(item)">
                </div>
                <p class="tc te every-me-text-h">{{item.name}}</p>
              </div>
            </div>
            <div class="flex cr fw all-video-y" v-if="titleState==2">
              <div v-for="(item,index) in myVideoArray" :key="index" class="all-every-me-fs">
                <div class="every-me-fs" :class="chooseVideoId==item.id?'actived':''"
                     :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}"
                     @click="handleChooseVideo(item)" @dblclick="handleDblclickVideo(item)">
                </div>
                <p class="tc te every-me-text">{{item.name}}</p>
              </div>
            </div>
          </div>
          <div class="flex mt25 ac jc">
            <el-button type="primary" style="background:rgb(108, 20, 255);border:none" @click="handleSubmitVideo">确定
            </el-button>
            <el-button @click="dialogVisible=false">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="video-dailog-box">
      <el-dialog
        :visible.sync="dialogVisible2"
        width="75%"
      >
        <div class="dialog-voice">
          <img class="close-img cr" src="https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.2_IconClose.png"
               alt="1" @click="dialogVisible2 = false">

          <!-- 音频选择-->
          <div class="all-voice-choose-box cr bbox">
            <div class="select-box flex ac cr mb15">
              <div v-for="(item,index) in tabsList" :key="index" class="every-tab" @click="handleTab(item)"
                   :style="{ color: item.id == tabId? '#222222' : '#222222AA'}">
                <p>{{item.name}}</p>
              </div>
            </div>
            <div v-if="tabId==0" class="voice-choose-box">
              <div class="flex ac fw">
                <div class="every-voice flex ac" v-for="(item,index) in voiceArray" :key="index"
                     :class="chooseVoiceId==item.id?'active': ''" @click="handleChooseVoice(item)"
                     @dblclick="handleDblclickVoice(item)">
                  <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                       @click="handlePlay2(item)">
                    <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                    <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                      <div class="play-pause-btn">
                        <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                           style="color: #ffffff;font-size: 25px"></i>
                        <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                        <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                             src="../assets/pcImages/voice-playing.gif">
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="pp4 te" :style="{ color: theme.homeColor8 }">{{item.name}}</p>
                    <p class="pp5" :style="{ color: theme.homeColor9 }">
                      {{site_title}}{{item.version_name}}音频</p>
                  </div>
                </div>
              </div>

            </div>
            <div v-if="tabId==1" class="voice-choose-box">
              <div class="flex ac fw">
                <div class="every-voice flex ac" v-for="(item,index) in myVoiceArray" :key="index"
                     :class="chooseVoiceId==item.id?'active': ''" @click="handleChooseVoice(item)"
                     @dblclick="handleDblclickVoice(item)">
                  <div class="card-img" @mouseover="handleMouse2(item)" @mouseleave="handleMouseOut2"
                       @click="handlePlay2(item)">
                    <img src="../assets/pcImages/1.3_Icon1@2x.png" alt="">
                    <div class="hover-box icon-player playing" v-if="mouseState && hoverId==item.id">
                      <div class="play-pause-btn">
                        <i class="el-icon-video-play" v-if="palyState==1 || clickId!=item.id"
                           style="color: #ffffff;font-size: 25px"></i>
                        <i class="el-icon-video-pause" v-if="palyState==2" style="color: #ffffff;font-size: 25px"></i>
                        <img class="playing-box" v-if="palyState==3 && clickId==item.id"
                             src="../assets/pcImages/voice-playing.gif">
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="pp4 te">{{item.name}}</p>
                    <p class="pp5" :style="{ color: theme.homeColor9 }">
                      {{site_title}}{{item.version_name}}音频</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex mt25 ac jc">
            <el-button type="primary" style="background:rgb(108, 20, 255);border:none" @click="handleAllSubmitVoice">全部场景使用
            </el-button>
            <el-button type="primary" style="background:rgb(108, 20, 255);border:none" @click="handleSubmitVoice">确定
            </el-button>
            <el-button @click="dialogVisible2=false">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <audio
      style="width: 1px;height: 1px;opacity: 0;position: fixed;right: 0;bottom: 0"
      ref="audioPlayer"
      :src="audioSrc"
      @ended="handleEnded"
      controls></audio>
  </div>
</template>
<script>
  import EditableDiv from './EditableDiv.vue'; // 引入上面创建的可编辑组件
  import {
    getAudition,
    getIndexVideo,
    getVideo,
    getVoice,
    postAudition,
    site,
    multiWorks,
    uploadSign,
    voiceEdit, uploadComplete, creditsLog
  } from "../api/user";

  export default {
    name: 'duochangjing',
    components: {
      EditableDiv,
    },

    data() {
      return {
        visible: false,
        textName: '未命名',
        name: '',
        inputState: false,
        rate: 1,
        volume: 1,
        pitch: 1,
        dialogVisible: false,
        dialogVisible2: false,
        titleState: 1,
        hsState: 1,
        chooseVideoId: null,
        tabsList: [{
          id: 0, name: '公共音频'
        }, {id: 1, name: '我的音频'}],
        tabId: 0,
        chooseVoiceId: null,
        audioSrc: '',
        voiceId: '',
        clickId: false,
        videoArray: [],
        myVideoArray: [],
        site_title: '',
        myVoiceArray: [],
        voiceArray: [],
        mouseState: false,
        palyState: 1,

        bulrIndex: null,
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        uploadSize: '',
        duration: 0,
        multipleIndex: null,
        multipleVideoObj: {},
        multipleVoiceObj: {},
        multiplesArray: [
          {
            id: Date.now() + Math.random(), // 添加唯一ID
            type: 'text',
            cover: '',
            video_id: '',
            voice_id: '',
            version_name: '',
            voice_name: '',
            placeholderApi: null,
            shitingplayState: 1,
            rate: 1,
            volume: 1,
            pitch: 1,
            visible: false,
            content: '',
            content2: '',
            sucessVoiceUrl22: '',

            file_id11: '',
            file_id22: '',

            videoDuration: 0,
            voiceUpDuration: 0,
            wenBenDuration: 0,
            tyDuration: 0,

            voiceUpName: "",
            upVoiceUrl: "",
          }
        ],
        drive_mode: 'serial',
        output_mode: 'video',
        addItemObj: {},
        allYgTimes: 0
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      this.getVideoList()
      this.getMyVideoList()
      this.getSite()
      this.getVoiceList()
      this.getMyVoiceList()
      this.getUploadSign()
    },
    methods: {
      // 获取配置
      getSite() {
        site().then(res => {
          this.site_title = res.data.site_title ? res.data.site_title : 'AI超级分身'
        })
      },
      getUploadSign() {
        uploadSign({file_type: 'voice'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      showInput() {
        this.inputState = true
        this.$nextTick(() => {
          this.$refs.inputRef.focus();
        })
      },
      handleBlur() {
        this.textName = this.name ? this.name : '未命名'
        this.inputState = false
      },
      handleHhmr() {
        voiceEdit({voice_id: this.chooseVoiceId, rate: 1, volume: 1, pitch: 1}).then(res => {
          // this.$message.success(res.msg)
          if (res.msg) {
            this.$message.success(res.msg)
          } else {
            this.$message.success('操作成功！')
          }
          this.sucessVoiceUrl22 = ''
          this.rate = 1
          this.volume = 1
          this.pitch = 1
          this.getVoiceList()
          this.getMyVoiceList()
        })
      },
      handleQrxg() {
        voiceEdit({voice_id: this.chooseVoiceId, rate: this.rate, volume: this.volume, pitch: this.pitch}).then(res => {
          if (res.msg) {
            this.$message.success(res.msg)
          } else {
            this.$message.success('修改成功！')
          }
          this.sucessVoiceUrl22 = ''
          this.getVoiceList()
          this.getMyVoiceList()
        })
      },
      handleChoose1(val) {
        this.titleState = val
      },
      handleHs(val) {
        this.hsState = val
        this.getVideoList()
      },
      handleChooseVideo(item) {
        this.chooseVideoId = item.id
        this.multipleVideoObj = {}
        this.multipleVideoObj = item
      },
      // 双击视频
      async handleDblclickVideo(item) {
        this.dialogVisible = false
        this.multiplesArray[this.multipleIndex].cover = item.cover
        this.multiplesArray[this.multipleIndex].video_id = item.id
        await this.getVideoDuration(item.url).then(resp => {
          this.multiplesArray[this.multipleIndex].videoDuration = resp ? resp : 0
        })
      },
      handleDelCj(index) {
        this.$confirm('确定要删除这个场景吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.multiplesArray.splice(index, 1);
          this.getYgTimes(this.multiplesArray);
          this.$message.success('删除成功');
        }).catch(() => {
          // 用户取消删除
        });
      },
      chooseInfo(index, val) {
        this.multiplesArray[index].content = this.multiplesArray[index].content2
        this.multiplesArray[index].type = val

        if(val=='text'){
          this.multiplesArray[index].tyDuration = this.multiplesArray[index].wenBenDuration
        }
        if(val=='audio'){
          this.multiplesArray[index].tyDuration = this.multiplesArray[index].voiceUpDuration
        }
        this.getYgTimes(this.multiplesArray)
        this.$forceUpdate()
      },
      handleGhVideo(index) {
        // 记录操作视频的index
        this.multipleIndex = index
        this.chooseVideoId = null
        this.dialogVisible = true
      },
      handleGhVoice(index) {
        // 记录操作视频的index
        this.multipleIndex = index
        this.chooseVoiceId = null
        this.dialogVisible2 = true
      },
      async handleSubmitVideo() {
        this.dialogVisible = false
        this.multiplesArray[this.multipleIndex].cover = this.multipleVideoObj.cover
        this.multiplesArray[this.multipleIndex].video_id = this.multipleVideoObj.id
        await this.getVideoDuration(this.multipleVideoObj.url).then(resp => {
          this.multiplesArray[this.multipleIndex].videoDuration = resp ? resp : 0
        })
      },
      handleSubmitVoice() {
        this.dialogVisible2 = false

        this.multiplesArray[this.multipleIndex].voice_name = this.multipleVoiceObj.name
        this.multiplesArray[this.multipleIndex].version_name = this.multipleVoiceObj.version_name
        this.multiplesArray[this.multipleIndex].voice_id = this.multipleVoiceObj.id
        this.multiplesArray[this.multipleIndex].placeholderApi = this.multipleVoiceObj.api
        this.multiplesArray[this.multipleIndex].visible = false

        this.multiplesArray[this.multipleIndex].rate = this.multipleVoiceObj.rate
        this.multiplesArray[this.multipleIndex].volume = this.multipleVoiceObj.volume
        this.multiplesArray[this.multipleIndex].pitch = this.multipleVoiceObj.pitch

        this.multiplesArray[this.multipleIndex].sucessVoiceUrl22 = ''
        this.multiplesArray[this.multipleIndex].file_id11 = ''
      },

      handleAllSubmitVoice() {
        if(!this.chooseVoiceId){
          this.$message.error('请选择一个您的音频，覆盖全部场景!')
          return false
        }
        this.dialogVisible2 = false
        for (let i = 0; i < this.multiplesArray.length ; i++) {
          this.multiplesArray[i].voice_name = this.multipleVoiceObj.name
          this.multiplesArray[i].version_name = this.multipleVoiceObj.version_name
          this.multiplesArray[i].voice_id = this.multipleVoiceObj.id
          this.multiplesArray[i].placeholderApi = this.multipleVoiceObj.api
          this.multiplesArray[i].visible = false

          this.multiplesArray[i].rate = this.multipleVoiceObj.rate
          this.multiplesArray[i].volume = this.multipleVoiceObj.volume
          this.multiplesArray[i].pitch = this.multipleVoiceObj.pitch

          this.multiplesArray[i].sucessVoiceUrl22 = ''
          this.multiplesArray[i].file_id11 = ''
        }
      },

      getVideoList() {
        getIndexVideo({source: '2', page: 1, limit: 9999}).then(res => {
          if (this.hsState == 1) {
            this.videoArray = res.data.hlist
          } else {
            this.videoArray = res.data.slist
          }
          this.getVideoDuration(res.data.slist[0].url).then(resp => {
            this.multiplesArray[0].videoDuration = resp ? resp : 0
          })
          this.multiplesArray[0].cover = res.data.slist[0] ? res.data.slist[0].cover : ''
          this.multiplesArray[0].video_id = res.data.slist[0] ? res.data.slist[0].id : ''
        })
      },
      getMyVideoList() {
        getVideo({source: '1', page: 1, limit: 9999}).then(res => {
          this.myVideoArray = res.data.list
        })
      },
      getMyVoiceList() {
        getVoice({source: '1', page: 0, limit: 9999}).then(res => {
          this.myVoiceArray = res.data.list
        })
      },
      getVoiceList() {
        getVoice({source: '2', page: 0, limit: 99999}).then(res => {
          this.voiceArray = res.data.list
          this.multiplesArray[0].voice_name = res.data.list[0] ? res.data.list[0].name : ''
          this.multiplesArray[0].version_name = res.data.list[0] ? res.data.list[0].version_name : ''
          this.multiplesArray[0].voice_id = res.data.list[0] ? res.data.list[0].id : ''
          this.multiplesArray[0].placeholderApi = res.data.list[0] ? res.data.list[0].api : null

          this.multiplesArray[0].rate = res.data.list[0] ? res.data.list[0].rate : 1
          this.multiplesArray[0].volume = res.data.list[0] ? res.data.list[0].volume : 1
          this.multiplesArray[0].pitch = res.data.list[0] ? res.data.list[0].pitch : 1

        })
      },
      handleMouse2(item) {
        this.mouseState = true
        this.hoverId = item.id
      },
      handleMouseOut2() {
        if (this.palyState != 3) {
          this.mouseState = false
        }
      },
      handlePlay2(item) {
        this.mouseState = true
        this.clickId = item.id
        if (this.palyState == 1) {
          this.palyState = 3
          this.audioSrc = item.url
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer
            audio.load()
            audio.play()
          })
        } else if (this.palyState == 3) {
          this.palyState = 1
          this.$refs.audioPlayer.pause()
        }
      },
      handleReUplod() {
        this.fileList = []
        // 重置上传组件
        this.$refs.upload && this.$refs.upload.clearFiles();
        this.$refs.upload2 && this.$refs.upload2.clearFiles();
      },
      beforeAvatarUpload(file) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        this.addItemObj = {}
        this.addItemObj.voiceUpName = file.name
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension == 'mp3' || fileExtension == 'm4a' || fileExtension == 'wav') {
          return true
        } else {
          that.$message.error('请上传MP3/M4A/WAV格式的音频')
          return false
        }
      },
      beforeAvatarUpload2(file, index) {
        this.loading = this.$loading({
          lock: true,
          text: '上传中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        this.multiplesArray[index].voiceUpName = file.name
        const that = this
        var file_type = file.name.split('.').slice(-1)
        var file_name = that.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
          .random() * 100) + '.' + file_type
        that.needParam.key = file_name
        that.uploadSize = file.size

        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension == 'mp3' || fileExtension == 'm4a' || fileExtension == 'wav') {
          return true
        } else {
          that.$message.error('请上传MP3/M4A/WAV格式的音频')
          return false
        }
      },

      handleRemove() {
        this.fileList = []
      },
      // 获取音频时长
      getAudioDuration(url) {
        return new Promise((resolve, reject) => {
          let audioElement = new Audio(url);
          audioElement.addEventListener('loadedmetadata', () => {
            resolve(audioElement.duration);
          });
        });
      },
      // 获取视频时长
      getVideoDuration(url) {
        return new Promise((resolve, reject) => {
          const video = document.createElement('video');
          video.addEventListener('loadedmetadata', () => {
            resolve(video.duration);
          });
          video.src = url;
        });
      },
      // 删除上传音频
      handleDelUpVoice(index) {
        this.multiplesArray[index].voiceUpName = ''
        this.multiplesArray[index].upVoiceUrl = ''
        this.multiplesArray[index].voiceUpDuration = 0
        this.multiplesArray[index].file_id22 = ''
        this.$forceUpdate()
      },

      async handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`

        this.addItemObj.id = Date.now() + Math.random() // 添加唯一ID
        this.addItemObj.voice_id = this.voiceArray[0].id
        this.addItemObj.version_name = this.voiceArray[0].version_name
        this.addItemObj.voice_name = this.voiceArray[0].name
        this.addItemObj.placeholderApi = this.voiceArray[0].api
        this.addItemObj.sucessVoiceUrl22 = ''
        this.addItemObj.rate = this.voiceArray[0].rate
        this.addItemObj.volume = this.voiceArray[0].volume
        this.addItemObj.pitch = this.voiceArray[0].pitch


        this.addItemObj.shitingplayState = 1
        this.addItemObj.type = 'audio'
        this.addItemObj.upVoiceUrl = url
        this.addItemObj.voiceUpDuration = await this.getAudioDuration(url)
        this.addItemObj.tyDuration = this.addItemObj.voiceUpDuration
        await this.getVideoDuration(this.videoArray[0].url).then(resp => {
          this.addItemObj.videoDuration = resp ? resp : 0
        })
        uploadComplete({
          file_type: 'voice',
          size: this.uploadSize,
          duration: this.addItemObj.voiceUpDuration,
          url: url
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.addItemObj.file_id22 = res.data.file_id
            this.$message.success('上传成功')
            this.loading.close();
            this.addItemObj.cover = this.videoArray[0].cover,
              this.addItemObj.video_id = this.videoArray[0].id,
              this.multiplesArray.push(this.addItemObj)
            this.addItemObj = {}
            this.getYgTimes(this.multiplesArray)
          }
        }).catch(() => {
          this.loading.close();
        })
        this.$refs.upload && this.$refs.upload.clearFiles();

      },

      async handleFileUpSuccess2(file, index) {
        const url = `${this.uploadUrl}/${this.needParam.key}`

        this.multiplesArray[index].shitingplayState = 1
        this.multiplesArray[index].type = 'audio'
        this.multiplesArray[index].upVoiceUrl = url
        this.multiplesArray[index].voiceUpDuration = await this.getAudioDuration(url)

        this.multiplesArray[index].tyDuration = this.multiplesArray[index].voiceUpDuration


        uploadComplete({
          file_type: 'voice',
          size: this.uploadSize,
          duration: this.multiplesArray[index].voiceUpDuration,
          url: url
        }).then(res => {
          if (res.data.url && res.data.file_id) {
            this.multiplesArray[index].file_id22 = res.data.file_id
            this.$message.success('上传成功')
            this.loading.close();
            this.getYgTimes(this.multiplesArray)
          }
        }).catch(() => {
          this.loading.close();
        })
        // this.$refs.upload2 && this.$refs.upload2.clearFiles();
      },

      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },
      formatTime(seconds) {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60);
        return `${minutes < 10 ? '0' + minutes : minutes}:${remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds}`;
      },

      async addWenText() {

        const obj = {
          id: Date.now() + Math.random(), // 添加唯一ID
          type: 'text',
          cover: this.videoArray[0] ? this.videoArray[0].cover : '',
          video_id: this.videoArray[0] ? this.videoArray[0].id : '',
          voice_id: this.voiceArray[0] ? this.voiceArray[0].id : '',
          version_name: this.voiceArray[0] ? this.voiceArray[0].version_name : '',
          voice_name: this.voiceArray[0] ? this.voiceArray[0].name : '',
          placeholderApi: this.voiceArray[0] ? this.voiceArray[0].api : null,
          shitingplayState: 1,
          rate: 1,
          volume: 1,
          pitch: 1,
          visible: false,
          content: '',
          content2: '',
          sucessVoiceUrl22: '',
          file_id11: '',
        }
        if(this.videoArray[0]&&this.videoArray[0].url){
          await this.getVideoDuration(this.videoArray[0].url).then(resp => {
            obj.videoDuration = resp ? resp : 0
          })
        }
        this.multiplesArray.push(obj)
      },

      handlePlayUpVoice(index, val) {
        if (val == 1) {
          this.multiplesArray[index].shitingplayState = 2
          this.audioSrc = this.multiplesArray[index].upVoiceUrl
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer
            audio.load()
            audio.play()
          })
        } else {
          this.audioSrc && this.$refs.audioPlayer.pause()
          this.multiplesArray[index].shitingplayState = 1
        }
        this.$forceUpdate();
      },
      // 有关文本试听操作开始
      handleShiTing(val, index) {
        if (val == 1) {
          this.audioSrc && this.$refs.audioPlayer.pause()
          if (this.multiplesArray[index].content2 && this.multiplesArray[index].voice_id) {
            if (this.multiplesArray[index].sucessVoiceUrl22.length <= 0) {
              this.loading = this.$loading({
                lock: true,
                text: '合成中,请等待...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.6)'
              });
              postAudition({
                voice_id: this.multiplesArray[index].voice_id,
                text: this.washDate(this.multiplesArray[index].content2),
                rate: this.multiplesArray[index].rate ? this.multiplesArray[index].rate : '1',
                volume: this.multiplesArray[index].volume ? this.multiplesArray[index].volume : '1',
                pitch: this.multiplesArray[index].pitch ? this.multiplesArray[index].pitch : '1',
              }).then(res => {
                if (res.data.job_id) {
                  this.job_id = res.data.job_id
                }
              }).catch(() => {
                this.loading.close()
                return false
              }).then(() => {
                if (this.job_id) {
                  this.timeoutId = null
                  this.timeoutId = setInterval(() => {
                    this.getAuditionList(index);
                  }, 3000);
                }
              })
            } else {
              this.audioSrc = this.multiplesArray[index].sucessVoiceUrl22
              this.multiplesArray[index].shitingplayState = 2
              this.$nextTick(() => {
                const audio = this.$refs.audioPlayer
                audio.load()
                audio.play()
              })
            }
          } else {
            this.$message.error('请输入试听文本和选择数字声音')
          }
        } else if (val == 2) {
          this.multiplesArray[index].shitingplayState = 1
          this.audioSrc && this.$refs.audioPlayer.pause()
        }
        this.$forceUpdate();
      },

      // 试听版
      getAuditionList(index) {
        getAudition({job_id: this.job_id}).then(res => {
          if (res.data.status == 3) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.multiplesArray[index].sucessVoiceUrl22 = res.data.url
            this.multiplesArray[index].file_id11 = res.data.file_id
            this.loading.close();
            this.audioSrc = res.data.url
            this.$nextTick(() => {
              this.multiplesArray[index].shitingplayState = 2
              const audio = this.$refs.audioPlayer
              audio.load()
              audio.play()
            })
          } else if (res.data.status == 4) {
            if (this.timeoutId) {
              clearInterval(this.timeoutId)
            }
            this.loading.close();
            this.$message.error('声音合成失败，请重新尝试')
          }
        }).catch(error => {
          if (this.timeoutId) {
            clearInterval(this.timeoutId)
          }
          this.loading.close();
          this.$message.error(error.msg)
        })
        this.$forceUpdate();
      },

      handleEnded() {
        // 当音频播放完成时，更新状态
        this.multiplesArray.forEach(item => {
          item.shitingplayState = 1
        })
        this.$forceUpdate()
      },
      audioEnded() {
        this.palyState = 1
      },
      handleTab(item) {
        this.tabId = item.id
      },
      handleChooseVoice(item) {
        if (item.generate_status == 1) {
          this.$message.error('声音训练中，暂时无法选择')
          return false
        }
        if (item.generate_status == 3) {
          this.$message.error('声音训练失败，无法选择')
          return false
        }
        this.chooseVoiceId = item.id
        this.multipleVoiceObj = item
      },
      // 音频双击事件
      handleDblclickVoice(item) {
        if (item.generate_status == 1) {
          this.$message.error('声音训练中，暂时无法选择')
          return false
        }
        if (item.generate_status == 3) {
          this.$message.error('声音训练失败，无法选择')
          return false
        }
        this.dialogVisible2 = false
        this.multiplesArray[this.multipleIndex].voice_name = item.name
        this.multiplesArray[this.multipleIndex].version_name = item.version_name
        this.multiplesArray[this.multipleIndex].voice_id = item.id
        this.multiplesArray[this.multipleIndex].placeholderApi = item.api
        this.multiplesArray[this.multipleIndex].visible = false

        this.multiplesArray[this.multipleIndex].rate = item.rate
        this.multiplesArray[this.multipleIndex].volume = item.volume
        this.multiplesArray[this.multipleIndex].pitch = item.pitch

        this.multiplesArray[this.multipleIndex].sucessVoiceUrl22 = ''
        this.multiplesArray[this.multipleIndex].file_id11 = ''
      },
      handleInsert(item,index2) {
        // 遍历数组并修改对象
        this.multiplesArray.forEach((ele,index) => {
          if(index2!=index){
            ele['visible'] = false
          }
        });
        this.multiplesArray[index2].visible = !this.multiplesArray[index2].visible
        // item.visible = !item.visible
      },

      // 插入按钮
      insertImg(pas) {
        let a = `<button contenteditable="false" style="margin: 0 2px;
    border-radius: 5px;color: #EB9600;display: inline-block;background-color: #FDF1E1;
    padding: 2px 5px;font-size: 12px">${pas.name}</button>&nbsp;`
        document.execCommand('insertHTML', true, a)
        if (this.bulrIndex >= 0) {
          this.multiplesArray[this.bulrIndex].visible = false;
        }
      },
      bindDateChange(value, index) {
        this.bulrIndex = index
        this.multiplesArray[index].content2 = value;
        this.multiplesArray[index].sucessVoiceUrl22 = '';
        this.multiplesArray[index].file_id11 = '';
        this.multiplesArray[index].wenBenDuration = 0;
        this.multiplesArray[index].wenBenDuration = this.removeTagsAndCountWords(this.washDate(value)) * 1 + this.getTdTime(this.washDate(value)) * 1

        this.multiplesArray[index].tyDuration = this.multiplesArray[index].wenBenDuration;

        this.getYgTimes(this.multiplesArray)
      },
      chooseMode(val) {
        this.drive_mode = val
      },
      chooseMode2(val) {
        this.output_mode = val
      },
      // 提交合成
      preview() {
        this.loading = this.$loading({
          lock: true,
          text: '生成中,请等待...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        var list = this.multiplesArray
        for (let i = 0; i < list.length; i++) {
          if(list[i].type == 'text'){
            if(list[i].content2&&list[i].content2.length>0){
              list[i].content2 = this.washDate(list[i].content2)
            }else {
              this.loading.close()
              this.$message.error('请填写文本内容')
              return false
              break
            }
          }

          if(list[i].type == 'audio'){
            if(list[i].upVoiceUrl == '' && list[i].voiceUpName==''){
              this.loading.close()
              this.$message.error('请上传音频')
              return false
              break
            }
          }
          // if (!this.compareFloat(list[i].videoDuration, list[i].tyDuration)) {
          //   this.$message.error(`场景${i + 1}视频时长应该大于等于音频时长`)
          //   this.loading.close()
          //   return false
          //   break
          // }
        }
        const array = []
        for (let i = 0; i < list.length; i++) {
          let paramsObj = {
            type: '',
            file_id: '',
            text: '',
            voice_id: '',
            rate: '',
            volume: '',
            pitch: '',
            video_id: '',
            video_duration: 0
          }

          paramsObj.type = list[i].type ? list[i].type : ''
          if(list[i].type=='text'){
            paramsObj.file_id = list[i].file_id11 ? list[i].file_id11 : ''
          }
          if(list[i].type=='audio'){
            paramsObj.file_id = list[i].file_id22 ? list[i].file_id22 : ''
          }
          paramsObj.text = list[i].content2 ? list[i].content2 : ''
          paramsObj.voice_id = list[i].voice_id ? list[i].voice_id : ''
          paramsObj.rate = list[i].rate ? list[i].rate : ''
          paramsObj.volume = list[i].volume ? list[i].volume : ''
          paramsObj.pitch = list[i].pitch ? list[i].pitch : ''
          paramsObj.video_id = list[i].video_id ? list[i].video_id : ''
          paramsObj.video_duration = list[i].videoDuration ? list[i].videoDuration : 0
          array.push(paramsObj)
        }

        multiWorks(
          {
            name: this.textName,
            api: 'fy',
            drive_mode: this.drive_mode,
            output_mode: this.output_mode,
            content: JSON.stringify(array)
          }
        ).then(res => {
          this.loading.close()
          this.$message.success(res.msg)
          this.$router.push({
            path: '/works',
            query: {
              type1: 1
            }
          })
        }).catch(error => {
          this.loading.close()
          this.$message.error(error.msg)
        })
        this.$store.dispatch('updatePoints')
      },
      // 处理数据
      washDate(value) {
        if (value) {
          value = value.replace(/&nbsp;/g, '')
          // 正则提取秒数
          const regex = /<button[^>]*>停顿([\d.]+)s<\/button>/g;
          let match;
          let updatedHtml = value;
          // 循环匹配每个<button>标签并替换成<break>标签
          while ((match = regex.exec(value)) !== null) {
            const seconds = match[1]; // 提取秒数
            const breakTag = `<break>${seconds}</break>`; // 用<break>标签封装
            updatedHtml = updatedHtml.replace(match[0], breakTag); // 替换原始<button>标签
          }
          return updatedHtml; // 更新显示内容
        }
      },
      // 获取预估总时长
      getYgTimes(array) {
        var allTimes = 0
        for (let i = 0; i < array.length; i++) {
          if (array[i].tyDuration) {
            allTimes += array[i].tyDuration * 1
          }
        }
        this.allYgTimes = allTimes
      },
      // 停顿的时长
      getTdTime(value) {
        const regex = /<break>(.*?)<\/break>/g;
        let match;
        const contents = [];
        while ((match = regex.exec(value)) !== null) {
          contents.push(match[1]);
        }
        const sum = contents.reduce((accumulator, currentValue) => {
          return accumulator * 1 + currentValue * 1;
        }, 0);
        return sum
      },
      removeTagsAndCountWords(str) {
        let cleanedStr = str.replace(/<break>.*?<\/break>/g, '');
        // 统计处理后字符串的字数
        let wordCount = cleanedStr.length;
        return (wordCount * 1 / 4.2).toFixed(1);
      },
      // 数值之间比较大小
      compareFloat(a, b) {
        const diff = Math.abs(a - b);
        if (diff < Number.EPSILON) {
          return true
        } else if (a < b) {
          // 视频时长小于音频时长
          return false
        } else {
          return true
        }
      },

      handleScrollUpdate: _.throttle(function() {
        this.multiplesArray.forEach((ele) => {
          ele['visible'] = false
        });
      }, 100)
    },
    mounted() {
      this.$refs.scrollContainer.addEventListener('scroll', this.handleScrollUpdate);
    },
    beforeDestroy() {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScrollUpdate);
    },
  }
</script>
<style scoped lang="scss">

  .main-cj-box {
    p {
      margin: 0;
      padding: 0;
    }

    .cj-name-box {
      width: 100%;
      padding: 22px 40px;
      border-bottom: 1px solid #393C4E;
      margin-bottom: 23px;

      .pp2 {
        font-weight: 500;
        font-size: 16px;
        color: #FAFAFA;
        text-align: left;
      }

      .tishi-img {
        width: 20px;
        height: 20px;
        display: block;
        margin-right: 8px;
      }
    }
  }

  .dcj-info-box {
    height: calc(100vh - 216px);
  }
  .left-info-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .left-info-box {
    min-width: 1416px;
    height: 100%;
    padding: 0 24px;
    // 隐藏滚动条
    overflow-y: scroll;
    -ms-overflow-style: none; /* 对于IE和Edge */
    scrollbar-width: none; /* 对于FireFox */

    .every-chang-jing {
      width: 1368px;
      height: 272px;
      background: #2C314C;
      border-radius: 12px;
      padding: 12px 24px;
      margin-bottom: 24px;

      p {
        margin: 0;
        padding: 0;
      }
    }

    .add-info-box {
      margin: 24px 0;

      .add-btn {
        width: 128px;
        height: 40px;
        background: #6C14FF;
        border-radius: 8px;

        font-weight: 500;
        font-size: 14px;
        color: #FAFAFA;
        margin-left: 12px;

        img {
          width: 20px;
          height: 20px;
        }
      }
    }

    .cj-title-box {
      margin-bottom: 12px;

      .moren-info-box {
        font-size: 12px;
        padding: 8px 15px;
        margin-right: 10px;
        border-radius: 5px;
        background: rgba(250, 250, 250, 0.08);
      }

      .choosed-info {
        font-size: 12px;
        padding: 8px 15px;
        margin-right: 10px;
        border-radius: 5px;
        background: #6C14FF;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }

    .left1-box {
      width: 150px;
      height: 200px;
      border-radius: 8px;
      background: rgba(250, 250, 250, 0.08);
      position: relative;
      margin-right: 16px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        object-fit: contain;
      }

      .qie-huan-btn {
        position: absolute;
        width: 100%;
        height: 32px;
        background: #FFFFFF;
        border-radius: 0px 0px 8px 8px;
        opacity: 0.95;
        bottom: 0;
        left: 0;

        font-weight: 500;
        font-size: 12px;
        color: #6C14FF;
        line-height: 32px;

        img {
          width: 20px;
          height: 20px;
          display: block;
          margin-right: 4px;
        }
      }
    }

    .voice-up-box {
      width: 1168px;
      height: 200px;
      background: rgba(250, 250, 250, 0.08);
      border-radius: 8px;
      color: #FAFAFA;

      .up-voice-info {
        width: 448px;
        height: 80px;
        background: rgba(9, 11, 39, 0.3);
        border-radius: 8px;
        padding: 18px 16px;

        .voiceUp1 {
          width: 44px;
          height: 44px;
          display: block;
        }

        .voiceUp2 {
          width: 260px;
          margin: 0 15px;

          .voice-text1 {
            font-weight: 400;
            font-size: 16px;
            color: #FAFAFA;
            margin-bottom: 4px;
          }

          .voice-text2 {
            font-weight: 400;
            font-size: 12px;
            color: #FAFAFAAA;
          }
        }

        .voiceUp3 {
          width: 72px;
          height: 28px;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.15);

          img {
            width: 18px;
            height: 18px;
            display: block;
          }

          font-weight: 500;
          font-size: 12px;
          color: #01FBF5;
        }
      }
    }

    .cj-right-box {
      width: 320px;
      height: 200px;
      background: rgba(250, 250, 250, 0.08);
      border-radius: 8px;
      margin-left: 16px;
      color: #FAFAFA;

      .yp-title-box {
        padding: 16px;
        border-bottom: 1px solid rgba(250, 250, 250, 0.1);

        img {
          width: 40px;
          height: 40px;
        }

        .yp-title-middle {
          width: 160px;

          .yp-text1 {
            width: 100%;
            font-weight: 500;
            font-size: 14px;
            color: #FAFAFA;
            margin-bottom: 4px;
          }

          .yp-text2 {
            width: 100%;
            font-weight: 400;
            font-size: 12px;
            color: #FAFAFAAA;
          }
        }

        .yp-title-btn {
          width: 64px;
          height: 28px;
          background: #6C14FF;
          border-radius: 4px;

          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
          line-height: 28px;
          text-align: center;
        }
      }

      .voice-tj-box {
        padding: 16px;

        .text1 {
          font-weight: 500;
          font-size: 12px;
          color: #FAFAFA;
        }

        .btn11, .btn22 {
          padding: 0 14px;
          height: 28px;
          border-radius: 6px;
          background: #575970;

          font-weight: 400;
          font-size: 12px;
          color: #EEEEEEAA;
        }

        .shezhi-box {
          width: 260px;
          height: 68px;
          border-radius: 8px;
          margin-top: 6px;

          font-weight: 500;
          font-size: 12px;
          color: #FAFAFA;

          .part-slider {
            height: 22px;
          }
        }
      }
    }

    .rich-text-box {
      width: 818px;
      height: 200px;
      background: #01021D;
      border-radius: 5px;
      position: relative;

      .all-editBox::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .all-editBox {
        font-size: 14px;
        padding: 8px;
        width: 818px;
        height: 160px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* 对于IE和Edge */
        scrollbar-width: none; /* 对于FireFox */
        .editBox {
          width: 100%;
          height: 100%;
        }
      }

      .handle-rich-box {
        position: absolute;
        bottom: 10px;

        .td-box {
          padding: 6px 18px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.15);


          .icon-td-img {
            width: 17px;
            height: 16px;
            display: block;
            margin-right: 4px;
          }
        }

        .st-part {
          img {
            width: 16px;
            height: 16px;
          }

          /*width: 88px;*/
          padding: 0 14px;
          height: 28px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          font-weight: 500;
          font-size: 12px;
          color: #FFFFFF;
        }
      }
    }
  }

  .right-info-box {
    width: 280px;
    height: calc(100vh - 216px);
    // 隐藏滚动条
    overflow-y: scroll;
    -ms-overflow-style: none; /* 对于IE和Edge */
    scrollbar-width: none; /* 对于FireFox */
    background: #2C314C;
    border-radius: 12px;

    .gj-title {
      font-weight: 500;
      font-size: 14px;
      color: #EEEEEE;
      padding: 13px 14px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      p {
        margin: 0;
        padding: 0;
      }

      img {
        width: 20px;
        height: 20px;
        display: block;
        margin-right: 4px;
      }

    }

    .small-title {
      cursor: pointer;
      width: 130px;
      font-weight: 500;
      font-size: 14px;
      color: #EEEEEE;
      padding: 16px 16px 12px;

      img {
        width: 14px;
        height: 14px;
        display: block;
        margin-left: 6px;
      }
    }

    .choose-ms-box {
      padding: 0 16px;
      margin-bottom: 8px;

      .moren-ys-box {
        width: 118px;
        height: 44px;
        background: rgba(250, 250, 250, 0.08);
        border-radius: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #EEEEEE;
        line-height: 44px;
        text-align: center;
      }

      .xz-ys-box {
        width: 118px;
        height: 44px;
        background: rgba(169, 185, 225, 0.2);
        border-radius: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #01FBF5;
        line-height: 44px;
        text-align: center;
      }

      .dan-xz-ys-box {
        width: 100%;
        height: 44px;
        background: rgba(169, 185, 225, 0.2);
        border-radius: 8px;
        font-weight: 400;
        font-size: 14px;
        color: #01FBF5;
        line-height: 44px;
        text-align: center;
      }
    }
  }
  .right-info-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .bottom-hc-box {
    width: 1720px;
    height: 75px;
    background: rgba(255, 255, 255, 0.2);
    padding: 0 32px;

    p {
      margin: 0;
      padding: 0;
      width: 170px;
      height: 36px;
      background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border-radius: 8px;

      font-weight: 600;
      font-size: 17px;
      color: #FFFFFF;
      line-height: 36px;
      text-align: center;
    }
  }

  .dialog-video {
    width: 100%;
    height: 76vh;
    background: url('https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.2_dialog_Bg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    border-radius: 12px;
    padding: 37px 40px;

    .close-img {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .part1-box {
      .select-box {
        width: 100%;
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
        padding-bottom: 17px;
        margin-bottom: 16px;

        .pp1 {
          font-weight: 500;
          font-size: 16px;
          color: #222222AA;
          margin-right: 16px;
        }

        .pp1-active {
          color: #222222 !important;
        }

        .hs-box {
          width: 90px;
          height: 28px;
          background: #FFFFFF;
          border-radius: 6px;

          .normal {
            width: 44px;
            height: 24px;
            border-radius: 4px;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 24px;
          }

          .hs-active {
            background: #6C14FF;
            border-radius: 4px;
            color: #ffffff;
          }
        }
      }
      .all-video-y::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .all-video-y {
        width: 100%;
        height: calc(70vh - 130px);
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
      }
      .all-video-y ::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      .all-every-me-fs {
        margin-right: 23px;
      }

      .every-me-fs {
        width: 159px;
        height: 212px;
        border-radius: 8px;
        background-size: cover;
        background-position: center;
      }

      .every-me-text {
        width: 159px;
        height: 40px;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 40px;
      }

      .all-every-me-fs-h {
        margin-right: 23px;
      }

      .every-me-fs-h {
        width: 230px;
        height: 140px;
        background-size: 100% 100%;
        border-radius: 8px;
      }


      .every-me-text-h {
        width: 230px;
        height: 40px;
        font-weight: 400;
        font-size: 14px;
        color: #222222;
        line-height: 40px;
      }

      .actived {
        position: relative;
      }

      .actived::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url("../assets/pcImages/2.1_Icon_Choose@2x.png") no-repeat;
        background-size: 100% 100%;
        z-index: 9;
      }

      .actived-h {
        position: relative;
      }

      .actived-h::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: url("../assets/pcImages/2.1_Icon_Choose3@2x.png") no-repeat;
        background-size: 100% 100%;
        z-index: 9;
      }
    }
  }

  .dialog-voice {
    width: 100%;
    height: 76vh;
    background: url('https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/2.2_dialog_Bg.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    border-radius: 12px;
    padding: 37px 40px;

    .close-img {
      width: 32px;
      height: 32px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .all-voice-choose-box {
      .select-box {
        border-bottom: 1px solid rgba(151, 151, 151, 0.3);
        padding-bottom: 17px;
        margin-bottom: 16px;
      }
      .voice-choose-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }
      .voice-choose-box {
        width: 100%;
        height: calc(70vh - 130px);
        overflow-y: scroll;
        overflow-x: hidden;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* Internet Explorer 10+ */
      }
      .voice-choose-box::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }


      .every-voice {
        margin-bottom: 12px;
        padding: 16px 14px;
        margin-right: 25px;

        width: 238px;
        height: 80px;
        background: #3D4052;
        border-radius: 8px;


        .card-img {
          position: relative;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          margin-right: 16px;

          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 50%;
          }

          .hover-box {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            text-align: center;
            background: rgba(0, 0, 0, .5);
            border-radius: 50%;
            cursor: pointer;
            justify-content: center;
            align-items: center;

            .play-pause-btn {
              margin-top: 10px;

              .playing-box {
                width: 30px;
                height: 18px;
              }
            }
          }
        }

        .pp4 {
          width: 145px;
          font-weight: 400;
          font-size: 16px;
          color: #FAFAFA;
          text-align: left;
          margin-bottom: 4px;
        }

        .pp5 {
          font-weight: 400;
          font-size: 12px;
          color: #FAFAFAAA;
          text-align: left;
        }

        .all-tags {
          .every-tag {
            font-size: 12px;
            color: #5b647a;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
            font-weight: 400;
            background: #edeef7;
            border-radius: 4px;
            padding: 0 4px;
            white-space: nowrap;
            margin-right: 5px;
          }
        }
      }

      .every-tab {
        font-weight: 400;
        font-size: 16px;
        color: #FAFAFAAA;
        text-align: left;
        margin-right: 20px;
      }

      .activeTab {
        color: #01FBF5 !important;
      }


      .active {
        position: relative;
      }

      .active::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        background: url("../assets/pcImages/2.1_Icon_Choose2@2x.png") no-repeat;
        background-size: 100% 100%;
        z-index: 0;
        left: 0;
        top: 0;
      }


      img {
        width: 44px;
        height: 44px;
      }
    }
  }


</style>
<style>
  .video-dailog-box .el-dialog__header {
    display: none;
  }

  .video-dailog-box .el-dialog__body {
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/multiples.vue